import GET_MANAGE_PRICE_SETTING from "./getManagePriceSetting";
import GET_PRODUCT_TAGS from "./getProductTags";
import GET_PRODUCT_TYPE from "./getProductType";
import GET_VENDOR_BRAND_LIST from "./getVendorBrandList";
import GET_PRODUCT_AND_SELLER_PRODUCT from "./getProductAndSellerProduct";
import { GET_PRODUCT_LIST, GET_PRODUCT_LIST_PROVIDER } from "./getProductList";
import GET_VENDOR_VARIANT from "./getVendorVariant";
import GET_SELLER_VARIANT from "./getSellerVariant";
import { GET_PRODUCT_BY_IDS_SELLER, GET_PRODUCT_BY_IDS } from "./getBulkEditProducts";
import GET_PRODUCT from "./getProduct";
import GET_PRODUCT_PHYSICAL_SETTING from "./getProductPhysicalSetting";
import GET_PRODUCT_SETTING from "./getProductSetting";
import GET_PRODUCT_VERSION from "./getProductVersion";
import GET_WHOLESALE_SETTING from "./getWholeSaleSetting";
import GET_PRODUCT_DETAILS from "./getProductDetail";

export {
  GET_MANAGE_PRICE_SETTING,
  GET_PRODUCT_TAGS,
  GET_PRODUCT_TYPE,
  GET_VENDOR_BRAND_LIST,
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_PROVIDER,
  GET_PRODUCT_AND_SELLER_PRODUCT,
  GET_VENDOR_VARIANT,
  GET_SELLER_VARIANT,
  GET_PRODUCT_BY_IDS_SELLER,
  GET_PRODUCT,
  GET_PRODUCT_BY_IDS,
  GET_PRODUCT_PHYSICAL_SETTING,
  GET_PRODUCT_SETTING,
  GET_PRODUCT_VERSION,
  GET_WHOLESALE_SETTING,
};
